export default [
  {
    path: '/ip-access-control',
    component: () =>
      import(
        /* webpackChunkName: "access-settings" */ '@/view/pages/access-settings/AccessSettings.vue'
      ),
    children: [
      {
        path: '/',
        name: 'ip-access-control',
        component: () =>
          import(
            /* webpackChunkName: "access-settings-index" */ '@/view/pages/access-settings/AccessSettingsIndex.vue'
          ),
        meta: { title: 'Cấu hình kiểm soát truy cập IP - Clickbuy' },
      },
    ],
  },
];
